export default __webpack_public_path__ + "static/media/partner-chibi-clash.e9677e0c.png";